import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppPrice } from '@galaxy/marketplace-apps';
import { Addon } from '@galaxy/marketplace-apps/v1';
import { Product } from '../shared/product';

@Component({
  selector: 'store-product-details',
  templateUrl: 'product-details.component.html',
  styleUrls: ['./product-details.component.scss'],
  standalone: false,
})
export class VaProductDetailsComponent {
  @Input() product: Product;
  @Input() appPrice: AppPrice;
  @Input() hasVerifiedContract = false;
  @Input() canAccessContractPricing = false;
  @Input() showActionButton = false;
  @Input() showPricing = false;
  @Input() pricingLabel = 'Wholesale Price';
  @Input() primaryPricingActionLabel: string;
  @Input() pricingActionLabel: string;
  @Input() showPricingAction = false;
  @Input() loaded = true;
  @Input() partnerID: string;
  @Input() partnerCurrency: string;

  @Output() enableClicked = new EventEmitter();
  @Output() addonSelected = new EventEmitter<string>();
  @Output() primaryPricingActionSelected = new EventEmitter();
  @Output() pricingActionSelected = new EventEmitter();
  private _addons: Addon[];

  getAddons(): Addon[] {
    if (!this._addons) {
      this._addons = this.product.addons.map((addon) => Addon.fromApi(addon));
    }
    return this._addons;
  }

  getActionLabel(): string {
    if (this.product.isArchived) {
      return 'Enable';
    }
    return 'Enabled';
  }

  onAddonSelected(addonId: string): void {
    this.addonSelected.emit(addonId);
  }
}
